/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import { useUnstyled as u, classNames as o, uTextBox as x } from "@progress/kendo-react-common";
const f = e.forwardRef(
  ({ orientation: t = "horizontal", ...s }, r) => {
    const a = e.useRef(null), m = e.useRef(null), n = u(), l = n && n.uTextBox;
    e.useImperativeHandle(a, () => ({ element: m.current })), e.useImperativeHandle(r, () => a.current);
    const c = e.useMemo(
      () => o(
        x.prefix({
          c: l,
          orientation: t
        }),
        s.className
      ),
      [s.className, l, t]
    );
    return /* @__PURE__ */ e.createElement("span", { ...s, className: c });
  }
);
f.displayName = "KendoReactInputPrefix";
export {
  f as InputPrefix
};
